import { IconCreditCard, IconInfoCircle } from '@tabler/icons-react';
import { PaymentCreditCardDto } from '@zorro/clients';
import { Switch } from '@zorro/design-system/v2/Switch';
import { Title } from '@zorro/design-system/v2/Title';
import { Group, Icon, Stack, Text } from '@zorro/web/design-system';
import { CreditCard } from '@zorro/web/shared-ui';
import { ChangeEvent } from 'react';

type Props = {
  creditCard?: PaymentCreditCardDto;
  badgeType?: 'in-handling' | 'not-available' | null;
  badgeText: string;
  withDetails?: boolean;
  withHeader?: boolean;
  onToggle?: (event: ChangeEvent<HTMLInputElement>) => void;
};

export const PaymentCardDetails = ({
  creditCard,
  badgeType,
  badgeText,
  withDetails,
  withHeader = false,
  onToggle,
}: Props) => {
  if (!creditCard) {
    return (
      <Stack gap="sm">
        {withHeader && (
          <Group gap="xxs">
            <Icon icon={IconCreditCard} size={20} />
            <Title order={3} size="sm">
              Payment method details
            </Title>
          </Group>
        )}
        <CreditCard badgeType={badgeType} />
        {badgeText && (
          <Group gap="xs" wrap="nowrap">
            <Icon icon={IconInfoCircle} />
            <Text size="sm">{badgeText}</Text>
          </Group>
        )}
      </Stack>
    );
  }

  const { billingAddress } = creditCard;

  return (
    <Stack gap="sm">
      {withHeader && (
        <Group gap="xxs">
          <Icon icon={IconCreditCard} size={20} />
          <Title order={4} size="sm">
            Card details
          </Title>
        </Group>
      )}
      <CreditCard {...creditCard} isMasked={!withDetails} />
      <Switch
        label="Show card details"
        checked={withDetails}
        onChange={onToggle}
      />
      <Stack pt="xs" gap={0}>
        <Text size="sm">
          <Text span fw={600} size="sm">
            {'Billing address: '}
          </Text>
          {billingAddress}
        </Text>
      </Stack>
      {badgeText && (
        <Group gap="xs" wrap="nowrap">
          <Icon icon={IconInfoCircle} />
          <Text size="sm">{badgeText}</Text>
        </Group>
      )}
    </Stack>
  );
};
